// libs
import * as React from 'react'

// interfaces / constants
import { IUnknownNotification } from 'src/interfaces/notification'

// classes / components
import Notification, { clsText, NotificationProps } from 'src/components/notifications/notification'

// helpers
import DateFormatter from 'src/utils/date_formatter/date_formatter'

export interface IProps extends IUnknownNotification {
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
}

export type UnknownNotificationProps = {
  message:string
  createdAt: string
} & Pick<NotificationProps, 'avatarImage' | 'initiatorName' | 'isRead' | 'onClick'>

const UnknownNotification: React.FC<UnknownNotificationProps> = ({
  avatarImage,
  createdAt,
  initiatorName,
  isRead,
  message,
  onClick
}) => {
  return (
    <Notification
      avatarImage={avatarImage}
      footer={DateFormatter.asTimeAgo(createdAt)}
      isRead={isRead}
      onClick={onClick}
      initiatorName={initiatorName}
    >
      {/* needs empty space between initiatorName and this text */}
      <span className={clsText}>{` ${message}`}</span>
    </Notification>
  )
}

export default UnknownNotification
